import { render, staticRenderFns } from "./USC_BAN10_ONLY.vue?vue&type=template&id=2d0b577c"
import script from "./USC_BAN10_ONLY.vue?vue&type=script&lang=js"
export * from "./USC_BAN10_ONLY.vue?vue&type=script&lang=js"
import style0 from "./USC_BAN10_ONLY.vue?vue&type=style&index=0&id=2d0b577c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports